import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface AIInstructionDialogProps {
  open: boolean;
  onClose: () => void;
  action: string | null;
  value: string;
  onChange: (val: string) => void;
  onSubmit: () => void;
  isProcessing: boolean;
}

export function AIInstructionDialog({
  open,
  onClose,
  action,
  value,
  onChange,
  onSubmit,
  isProcessing
}: AIInstructionDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          bgcolor: 'background.paper',
          backgroundImage: 'none',
          border: '1px solid',
          borderColor: 'divider',
        },
      }}
    >
      <DialogTitle sx={{ pb: 1, fontWeight: 700 }}>
        {action === 'rewrite_selection'
          ? t('editor.rewrite_selection_title')
          : t('editor.adjust_pacing_title')}
      </DialogTitle>
      <DialogContent sx={{ pb: 2 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {action === 'rewrite_selection'
            ? t('editor.rewrite_selection_desc')
            : t('editor.adjust_pacing_desc')}
        </Typography>
        <TextField
          autoFocus
          margin="dense"
          label={t('editor.instructions_label')}
          type="text"
          fullWidth
          variant="outlined"
          multiline
          rows={3}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={
            action === 'rewrite_selection'
              ? t('editor.rewrite_placeholder')
              : t('editor.adjust_pacing_placeholder')
          }
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button onClick={onClose} color="inherit">
          {t('editor.cancel')}
        </Button>
        <Button
          onClick={onSubmit}
          variant="contained"
          color="primary"
          disabled={isProcessing}
        >
          {t('editor.generate')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
